import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled", "aria-label"]

import { computed } from 'vue';

interface Props {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'secondary' | 'ghost';
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  ariaLabel?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    size: { default: 'md' },
    variant: { default: 'primary' },
    disabled: { type: Boolean, default: false },
    type: { default: 'button' },
    ariaLabel: { default: '' }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const buttonClasses = computed(() => {
  const baseClasses = 'icon-btn';
  const variantClass = `icon-btn-${props.variant}`;
  const sizeClass = `icon-btn-${props.size}`;
  const disabledClass = props.disabled ? 'opacity-50 cursor-not-allowed' : '';

  return [baseClasses, variantClass, sizeClass, disabledClass].join(' ');
});

function handleClick(event: MouseEvent) {
  if (!props.disabled) {
    emit('click', event);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    disabled: __props.disabled,
    class: _normalizeClass(buttonClasses.value),
    onClick: handleClick,
    "aria-label": __props.ariaLabel
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})